/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-29 13:38:34
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-10-14 11:37:12
 * @Description: file content
 */
import Vue from "vue/dist/vue.js";
import modalForm from "./components/modal-form";
import modalFormSuccess from "./components/modal-formSuccess";
import modalForm2 from "./components/modal-form2";
import modalHelp from "./components/modal-help";
import modalShare from "./components/modal-share";
import modalPoster from "./components/modal-poster";
import modalPoster2 from "./components/modal-poster2";
import modalQrCode from "./components/modal-qrCode";
import modalLuck from "./components/modal-luck";
import modalSignForm from "./components/modal-signForm";

let myPlugin = {
  options: null,
};
myPlugin.install = function (Vue) {
  Vue.prototype.$modal = {
    form: modalForm,
    formSuccess: modalFormSuccess,
    form2: modalForm2,
    help: modalHelp,
    share: modalShare,
    poster: modalPoster,
    poster2: modalPoster2,
    qrCode: modalQrCode,
    luck: modalLuck,
    signForm: modalSignForm,
  };
};
Vue.use(myPlugin);
